function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgStar = function SvgStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("path", {
    style: {
      fill: "#FFCD38"
    },
    d: "M276.224,23.996l61.637,124.89c3.285,6.656,9.635,11.27,16.98,12.337l137.824,20.027 c18.498,2.688,25.884,25.421,12.499,38.468l-99.731,97.213c-5.316,5.181-7.741,12.647-6.486,19.962L422.49,474.16 c3.16,18.424-16.178,32.473-32.723,23.775l-123.274-64.809c-6.57-3.454-14.419-3.454-20.99,0l-123.274,64.809 c-16.546,8.699-35.883-5.351-32.723-23.775l23.543-137.266c1.255-7.316-1.17-14.781-6.486-19.962l-99.73-97.213 c-13.385-13.047-5.999-35.78,12.499-38.468l137.824-20.027c7.346-1.067,13.696-5.681,16.98-12.337l61.637-124.89 C244.049,7.234,267.951,7.234,276.224,23.996z"
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#3A484A"
    },
    d: "M184.081,270.145c-4.267,0-7.726-3.459-7.726-7.726V248.99c0-4.267,3.459-7.726,7.726-7.726 s7.726,3.459,7.726,7.726v13.428C191.807,266.685,188.348,270.145,184.081,270.145z"
  }), React.createElement("path", {
    style: {
      fill: "#3A484A"
    },
    d: "M327.919,270.145c-4.267,0-7.726-3.459-7.726-7.726V248.99c0-4.267,3.459-7.726,7.726-7.726 c4.267,0,7.726,3.459,7.726,7.726v13.428C335.645,266.685,332.186,270.145,327.919,270.145z"
  }), React.createElement("path", {
    style: {
      fill: "#3A484A"
    },
    d: "M234.103,251.431v12.89c0,12.093,9.803,21.896,21.896,21.896l0,0 c12.093,0,21.896-9.803,21.896-21.896v-12.89H234.103z"
  })), React.createElement("path", {
    style: {
      fill: "#EBAF03"
    },
    d: "M147.091,324.901c1.616-9.787-1.508-19.771-8.354-26.701L22.727,180.757l-3.392,0.493 C0.836,183.938-6.55,206.671,6.835,219.718l99.731,97.213c5.316,5.182,7.741,12.647,6.486,19.962L89.508,474.161 c-2.908,16.959,13.245,30.197,28.737,25.411L147.091,324.901z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star.c566b5be.svg";
export { ForwardRef as ReactComponent };